import { Injectable } from '@angular/core';
import { SiteTypeService } from 'src/api/services/site-type.service';
import { SiteType } from 'src/api/models/site-type';
import { BehaviorSubject, Observable } from "rxjs";
import { StrictHttpResponse } from 'src/api/strict-http-response';
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class SiteTypeTableService {

    public loading: boolean = false;

    public remoteData: Observable<SiteType[]>;
    private _remoteData: BehaviorSubject<SiteType[]>;

    constructor(public readonly service: SiteTypeService,private toasterService: ToastrService) {
      this._remoteData = new BehaviorSubject([]);
      this.remoteData = this._remoteData.asObservable();
    }

    get(customerId: number) {
      this.loading = true;
      this.service.SiteTypeGetAll(customerId).subscribe(results => {
        this.loading = false;
        this._remoteData.next(results);
      }, e => {
        this.loading = true;
      });
    }

    add(siteType: SiteType) {
      this.loading = true;
      return this.service.SiteTypeCreate(siteType).subscribe(s => {
        this.toasterService.success("Site Type Created");
        this.get(siteType.customerId);
      }, e =>{
        this.toasterService.error("Site Type Not Created");
      });
    }

    remove(siteType: SiteType) {
      this.loading = true;
      this.service.SiteTypeDelete(siteType.siteTypeId).subscribe(s => {
        this.toasterService.success("Site Type Deleted");
        this.get(siteType.customerId);
      }, e =>{
        this.toasterService.error("Site Type Not Deleted");
      });
    }

    update(siteType: SiteType) {
      return this.service.SiteTypeUpdate(siteType).subscribe(s => {
        this.toasterService.success("Site Type Updated");
        this.get(siteType.customerId);
      }, e =>{
        this.toasterService.error("Site Type Not Updated");
      });
    }


}
